<template>
  <v-dialog
    v-model="showModal"
    :width="width"
    :height="height"
    max-height="95vh"
    max-width="95vw"
    class="table-modal"
    :content-class="contentClass"
    persistent
  >
    <template #activator="{ props }">
      <slot
        name="activator"
        v-bind="{ props }"
      />
    </template>
    <v-card
      :width="width"
      :height="height"
      max-height="95vh"
      max-width="95vw"
    >
      <div class="table-modal-header">
        <slot name="header">
          <h5>{{ title }}</h5>
          <div class="d-flex">
            <DashboardSearchBar
              :light="true"
              :search-term="searchTerm"
              class="mr-2"
              @update:model-value="$emit('updateSearch', $event)"
            />
            <v-btn
              variant="flat"
              :ripple="false"
              icon
              @click="$emit('close')"
            >
              <v-icon
                size="18px"
                color="iconDefault"
                class="close-icon"
                icon="$close"
              />
            </v-btn>
          </div>
        </slot>
      </div>
      <div class="table-modal-table">
        <slot name="table" />
      </div>
      <div class="table-modal-footer">
        <div>
          <v-pagination
            v-if="pagination.totalPages > 1"
            :model-value="pagination.page"
            :total-visible="10"
            :length="pagination.totalPages"
            class="elevation-0"
            @update:model-value="(value) => $emit('updatePage', value)"
          />
        </div>
        <slot name="action" />
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import DashboardSearchBar from '@/components/shared/DashboardSearchBar.vue';

export default {
  name: 'TableModal',
  components: {
    DashboardSearchBar,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '1024px',
    },
    height: {
      type: String,
      default: '638px',
    },
    title: {
      type: String,
      default: '',
    },
    pagination: {
      type: Object,
      default() {
        return {
          totalPages: 0,
          page: 1,
        };
      },
    },
    searchTerm: {
      type: String,
      default: '',
    },
    contentClass: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'updatePage', 'updateSearch', 'setShow'],
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(value) {
        return this.$emit('setShow', value);
      },
    },
  },
};
</script>

<style lang="less" scoped>
:deep(.v-dialog) {
  overflow-y: hidden;
}

.table-modal-header {
  width: 100%;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  border-bottom: 1px solid @stroke-default;
}

.table-modal-table {
  width: 100%;
  height: calc(100% - 150px);

  :deep(tr), :deep(td) {
    height: 44px !important;
  }

  tr:hover {
    background-color: transparent !important;
  }

  .v-data-table__wrapper {
    padding: 0 24px;
    .text-start, .text-end {
      padding: 0;
    }
  }

  .v-data-table-header th {
    span {
      font-weight: 300 !important;
      font-size: 12px;
      line-height: 16px;
      color: @text-darkest;
    }
  }

  span {
    font-weight: 500;
  }
}

.table-modal-footer {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 14px;
  border-top: 1px solid @stroke-default;
}

.table-modal-footer :deep(.v-pagination) li button {
  box-shadow: none;
  background-color: transparent;
  border-radius: 5px;
  height: 24px;
  width: 24px;
  font-size: 12px;
  min-width: auto;
  margin: 4px;
}
.table-modal-footer :deep(.v-pagination) li button i {
  font-size: 20px;
  color: @text-darkest;
}
.table-modal-footer :deep(.v-pagination) li button.v-pagination__item--active {
  color: @white;
  background-color: @text-brand;
  font-weight: 500;
}
</style>
